import { BranchQueue, Counter } from '../common';
import { PlaySoundBehaviourType } from '../common/_types';

type MonitorItem = Counter | BranchQueue;

/**
 * Whether a pending-token event should trigger the "new token" sound, based on the
 * monitor's configured behaviour. Pure rule extracted from MonitorComponent.
 */
export function shouldPlayPendingSound(
  behaviour: PlaySoundBehaviourType,
  totalPeopleInQueue: number,
): boolean {
  if (behaviour === 'all_new_tokens') return true;
  return behaviour === 'people_in_queue_from_0_to_1' && totalPeopleInQueue === 1;
}

/** Find the monitor item a *serving* event belongs to (matched by the item's own id). */
export function findServingItem(
  items: MonitorItem[],
  itemType: string,
  attributes: { counterId?: number; branchQueueId?: number },
): MonitorItem | undefined {
  const itemId = itemType === 'counter' ? attributes.counterId : attributes.branchQueueId;
  return items.find((it) => it.id == itemId);
}

/** Find the monitor item a *pending* event belongs to (matched by branch queue). */
export function findPendingItem(
  items: MonitorItem[],
  itemType: string,
  branchQueueId: number,
): MonitorItem | undefined {
  return items.find((it) => (itemType === 'counter' ? (it as Counter).branchQueueId : it.id) == branchQueueId);
}
